import { DataRecoveryLegalCaseState } from './partials/legal-case'

export const DataRecoveryState = _ => ({
  dataRecovery: {
    ...DataRecoveryLegalCaseState,

    isSearching: false,
  },
})
